import { apiClient, buildQueryString } from '@/services/utils';

export default {
  getAll(params) {
    const queryString = buildQueryString(params)

    return apiClient.get(`/wear_like_this_images${queryString}`);
  },

  create(formData) {
    const config = { headers: { 'Content-Type': 'multipart/form-data' } }

    return apiClient.post(`/wear_like_this_images/`, formData, config)
  },

  destroy(id) {
    return apiClient.delete(`/wear_like_this_images/${id}`);
  }
}



// WEBPACK FOOTER //
// ./src/services/api/WearLikeThisImageService.js